<template>
<div class="custom-scrollbars">
  <div v-if="!!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer)" class="side-panel-overlay"></div>
  <aside v-if="!!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer)"
    class="sidePanelHelp"
    :class="{
      'help-panel-main-vertical': !!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer),
      'sidepanelHelpRight': !!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer),
      'sidepanelRight': !!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer),
      'help-panel-main-horizontal': false,
      'sidepanelHelpDown': false,
      'right': !!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer),
      'openHelp': !!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer)}"
    :style="helpStyle">
    <v-layout class="help-header align-center justify-space-between">
      <v-layout class="align-center">
        <v-icon>ecc:ecc-T-Help</v-icon><span data-qa="help-title" style="padding-left: 10px;">
          Need help?
        </span>
      </v-layout>
      <v-layout class="help-close-button align-center justify-end"
        data-qa="close-help"
        @click="store.drawerItems[props.id]?.toggle"
        :class="{ 'help-close-button-hover': false }">
        <span style="padding-right: 10px">
          Close
        </span><v-icon size="small">ecc:ecc-M-Chiudi</v-icon>
      </v-layout>
    </v-layout>
    <div style="width: 100%;" class="help-panel-content">
      <slot></slot>
    </div>
  </aside>
</div>
</template>

<style scoped>
  .sidepanel {
    position: fixed;
    top: 0;
    bottom: 0;
    transition: all 400ms;
    box-shadow: transparent 0 0 0;
  }

  .help-header {
    margin-bottom: 30px;
  }
  .help-header .v-icon {
    font-size: 22px;
    color: var(--color-g4);
  }
  .help-close-button{
    cursor: pointer;
    font-size: 12px;
    text-align: right;
    color: var(--color-dk);
  }
  .help-close-button .v-icon {
    font-size: 12px;
    color: var(--color-dk);
  }
  .help-close-button-hover, .help-close-button-hover .v-icon {
    color: var(--color-highlight);
    transition:0ms
  }

  .helpLogo{
    text-align-last: center;
    font-size: 12px;
  }
  .helpLogo .v-icon {
    font-size: 22px;
    color: var(--color-g4);
  }

  .help-panel-main-vertical {
  padding-top: 50px;
  padding-left: 30px;
  padding-right: 37px;  
  }
  .help-panel-main-horizontal {
    padding-top: 24px;
    padding-left: 60px;
    padding-right: 60px;    
  }

  .sidepanelHelpRight {
    display: none;
    overflow: auto;
    position: fixed;
    top: 0;
    bottom: 0;
    /* transition: all 400ms; */
    background-color: var(--color-wt);
    box-shadow: var(--shadow-editMenu);
    /* z-index: 199 !important;*/
    height: 100%;
  }
  .sidepanelHelpDown {
    display: none;
    overflow: auto;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 263px;
    width: 100%;
    transition: all 400ms;
    background-color: var(--color-wt);
    box-shadow: var(--shadow-editMenu);
    z-index: 1 !important;
  }
  .openHelp{
    display: block;
  }
  .sidepanel:not(.open) * {
    box-shadow: transparent 0 0 0;
  }

  .sidepanel.right {
    right: -30px; /* shadow margin */
    transform: translateX(100%);
  }

  .sidepanel:not(.right) {
    left: 0;
    transform: translateX(-100%);
  }

  .sidepanelHelp.right {
    right: 0;
    /* transform: translateX(100%); */
  }

  .sidepanelHelp:not(.right) {
    left: 0;
    /* transform: translateX(-100%); */
  }

  .sidepanel.right.open,
  .sidepanel:not(.right).open {
    transform: translateX(calc(0% - 30px)); /* to compensate shadow margin */
    box-shadow: rgb(95, 94, 94) 5px 0px 5px -5px;
  }

  .sidepanel-collapsed .sidePanelHelp {
    display: none;
  }
  .side-panel-overlay{
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: rgba(0,0,0,.5);
    z-index: 190;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
</style>

<script setup lang="ts">
import { store } from './Help.store';
import { computed } from 'vue';
import { useDisplay } from 'vuetify'

const props = defineProps<{
  id: string;
}>();

const helpStyle = computed(() => {
    let right = "0px";
    let width = "0px";
    if (useDisplay.name == "xs") {
      store.drawerItems[props.id]?.close();
    } else if (useDisplay.name == "sm") {
        right = "50%";
        width = "40%";
    } else {
        right = "500px";
        width = "400px";
    }
      
    return {
      width,
      right,
    }
})

</script>

